import { createInstance } from '@optimizely/react-sdk';

const optimizelyClientInstance = createInstance({
  sdkKey: process.env.REACT_APP_OPTIMIZELY_FRONT_END_SDK_KEY,
  logLevel: 'error',
});

export default optimizelyClientInstance;
